<template>
  <div class="detailContract" v-if="canAccessMx('CNPS_SCON_INFO_BY_ID')">
    <Header
      title="Chi tiết HĐG bán hàng"
      :backUrl="
        canAccessMx('CNPS_SCON_LIST_SELL')
          ? '/contract-manager?groupService=SELL'
          : '/contract-manager'
      "
    />
    <div class="d-flex">
      <ContractAction
        :actions="defaultContractAction"
        :excepts="[
          actCode.OTP,
          actCode.APPROVE_COLLARBORATOR,
          actCode.REJECT_COLLARBORATOR,
          actCode.APPROVE_REJECT_LIQUID,
          actCode.SYNC_MPOS,
          actCode.EXPERTISE,
        ]"
      />
      <b-button
        v-if="dataPermission && dataPermission.includes('CNPS_SCON_UPSERT_SELL_COMBO_CONTRACT')"
        style="height: 35px"
        class="btn btn-primary mr-2 mb-2"
        @click="openUploadModal"
        variant="primary"
      >
        Upload ảnh hợp đồng
      </b-button>
      <b-button
        v-if="dataPermission && dataPermission.includes('CNPS_SCON_MEGABIZ_UPDATE_STT')"
        style="height: 35px"
        class="btn btn-primary mr-2 mb-2"
        @click="openUpdateStatusModal"
        variant="primary"
      >
        Cập nhật trạng thái Megabiz
      </b-button>
    </div>

    <!-- End Breadcrumb Area -->
    <div class="row px-20 b-t-1-869fb229 pt-15">
      <div class="col-md-6 px-1">
        <McInfo :contract="dataContract" :item="customerInfo" />

        <ContractInfo
          :dataConfigMcc="dataConfigMcc"
          :submitEditMcc="submitEditMcc"
          :contract="dataContract"
          :listStatusMegabiz="statusOptions"
          :item="customerInfo"
        />
        <CusInfo :contract="dataContract" :item="customerInfo" />
        <BankInfo :contract="dataContract" :item="customerInfo" />
        <ReceiptInfo :contract="dataContract" :item="customerInfo" />
        <PaymentAcceptancePoint :contract="dataContract" :item="customerInfo" />
      </div>
      <div class="col-md-6 px-1">
        <div class="form-detail">
          <UploadMultiple
            :lsData="dataPDFContract"
            keyUrl="dataURL"
            :canUpload="false"
            title="Upload file PDF"
            titleTag="h1"
            titleClass="form-inner-heading"
          >
            <div
              v-if="
                ['SALE_ADMIN', 'SALE_DIRECTOR'].includes(dataUser.typeSale) &&
                dataContract.state === 'SIGNED_WAITING_APPROVED'
              "
              @click="showAddImages('pdf')"
              class="add-img btn"
            >
              <span class="text-center bx bx-edit-alt"></span>
            </div>
          </UploadMultiple>
          <UploadMultiple
            v-if="dataContract.typeCustomer === 'INDIVIDUAL'"
            :lsData="dataBillImg"
            keyUrl="dataURL"
            :canUpload="false"
            title="Ảnh hoá đơn/Ảnh selfie với cửa hàng/Ảnh sản phẩm..."
            titleTag="h1"
            titleClass="form-inner-heading"
          >
            <div
              v-if="
                ['SALE_ADMIN', 'SALE_DIRECTOR'].includes(dataUser.typeSale) &&
                dataContract.state === 'SIGNED_WAITING_APPROVED'
              "
              @click="showAddImages('selfie')"
              class="add-img btn"
            >
              <span class="text-center bx bx-edit-alt"></span>
            </div>
          </UploadMultiple>
          <UploadMultiple
            v-if="['HOUSEHOLD', 'COMPANY'].includes(dataContract.typeCustomer)"
            :lsData="dataDKKDImg"
            keyUrl="dataURL"
            :canUpload="false"
            title="Ảnh giấy phép KD/Ảnh selfie/Ảnh sản phẩm/Ảnh cửa hàng..."
            titleTag="h1"
            titleClass="form-inner-heading"
          >
            <div
              v-if="
                ['SALE_ADMIN', 'SALE_DIRECTOR'].includes(dataUser.typeSale) &&
                dataContract.state === 'SIGNED_WAITING_APPROVED'
              "
              @click="showAddImages('dkkd')"
              class="add-img btn"
            >
              <span class="text-center bx bx-edit-alt"></span>
            </div>
          </UploadMultiple>
          <UploadMultiple
            :lsData="dataPassportImg"
            keyUrl="dataURL"
            :canUpload="false"
            title="Ảnh CMND/CCCD/Hộ chiếu"
            titleTag="h1"
            titleClass="form-inner-heading"
          />
          <div v-if="dataContract.stores">
            <div class="img-list-wrapper" v-for="(item, index) in dataContract.stores" :key="index">
              <UploadMultiple
                :lsData="[item]"
                keyUrl="dataURL"
                :canUpload="false"
                :title="`Ảnh cửa hàng: ${compact([
                  item.areaAddress,
                  item.areaDistrict,
                  item.areaCity,
                ]).join(' - ')}`"
                titleTag="h1"
                titleClass="form-inner-heading"
              >
                <div
                  v-if="
                    ['SALE_ADMIN', 'SALE_DIRECTOR'].includes(dataUser.typeSale) &&
                    dataContract.state === 'SIGNED_WAITING_APPROVED'
                  "
                  @click="showAddImages('cuahang', item.areaId)"
                  class="add-img btn"
                >
                  <span class="text-center bx bx-edit-alt"></span>
                </div>
              </UploadMultiple>
            </div>
          </div>
          <div
            v-if="
              customerInfo.merchantBusinessAreas &&
              dataContract.state !== 'SIGNED_WAITING_APPROVED' &&
              !dataContract.stores
            "
          >
            <div
              class="img-list-wrapper"
              v-for="(item, index) in customerInfo.merchantBusinessAreas"
              :key="index"
            >
              <UploadMultiple
                :lsData="[item]"
                keyUrl="areaUrl"
                :canUpload="false"
                :title="`Ảnh cửa hàng: ${compact([
                  item.areaAddress,
                  item.areaDistrict,
                  item.areaCity,
                ]).join(' - ')}`"
                titleTag="h1"
                titleClass="form-inner-heading"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 px-1">
        <AppendixPackage
          :items="dataContract.appendixPackages"
          :only="['REQUEST_ADDITIONAL', 'RE_CREATE_RECEIPT', 'APPROVE_REJECT']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        >
          <template #row-details="item">
            <p>
              <button
                v-if="canAccessMx('CNPS_SCON_UPDATE_USERNAME_SELL')"
                @click="editUsername(item.appendixPackage.userNameStr, item.appendixId)"
                style="border: 1px solid #dee2e6"
              >
                <i class="bx bx-edit-alt"></i>
              </button>
              Danh sách username:
              {{ item.appendixPackage && item.appendixPackage.userNameStr }}
            </p>
          </template>
        </AppendixPackage>
        <AppendixDevice
          :items="dataContract.appendixDevices"
          :only="[
            'REQUEST_ADDITIONAL',
            'RE_CREATE_RECEIPT',
            'APPROVE_REJECT',
            'EDIT_DEVICE',
            'HANOVER_APPROVE_REJECT_NEW',
          ]"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixRecall
          :items="dataContract.appendixRecalls"
          :only="['REQUEST_ADDITIONAL', 'APPROVE_REJECT']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <AppendixHandover
          :items="dataContract.appendixHandOvers"
          :only="['REQUEST_ADDITIONAL', 'APPROVE_REJECT']"
          :actions="defaultAppendixAction"
          :contract="dataContract"
        />
        <SignHistory :contractId="$route.params.id" />
        <div class="form-detail" v-if="historyUpdate.length > 0">
          <h1>Lịch sử chỉnh sửa thông tin hợp đồng</h1>
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="text-left">Thông tin chỉnh sửa</th>
                  <th scope="col" class="text-left">Thời gian</th>
                  <th scope="col" class="text-left">Sale</th>
                  <th scope="col" class="text-left">Người duyệt/ từ chối</th>
                  <th scope="col" class="text-left">Lý do từ chối</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in historyUpdate" :key="index">
                <tr class="table-row">
                  <td align="left">
                    <router-link :to="`/history-approve-update/${item.updateCusReqId}`"
                      >Xem chi tiết</router-link
                    >
                  </td>
                  <td align="left">
                    {{ item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }} <br />
                  </td>
                  <td align="left">
                    {{ item.saleName }} <br />
                    <p class="text-primary">{{ item.saleEmail }}</p>
                  </td>
                  <td align="left">
                    <div v-if="item.rejectName">
                      {{ item.rejectName }} <br />
                      <p class="text-primary">{{ item.rejectEmail }}</p>
                    </div>
                    <div v-else>
                      {{ item.approverName }} <br />
                      <p class="text-primary">{{ item.approverEmail }}</p>
                    </div>
                  </td>
                  <td align="left">
                    {{ item.reason }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="form-detail" v-if="historyAssignSale.length > 0">
          <h1>Lịch sử gán hợp đồng</h1>
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead class="thead-light">
                <tr>
                  <th scope="col" class="text-left">Thời gian</th>
                  <th scope="col" class="text-left">Sale cũ</th>
                  <th scope="col" class="text-left">Sale đang gán</th>
                  <th scope="col" class="text-left">Người gán</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in historyAssignSale" :key="index">
                <tr class="table-row">
                  <td align="left">
                    {{ item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }} <br />
                  </td>
                  <td align="left">
                    {{ item.oldSaleName }} <br />
                    <p class="text-primary">{{ item.oldSaleEmail }}</p>
                  </td>
                  <td align="left">
                    {{ item.newSaleName }} <br />
                    <p class="text-primary">{{ item.newSaleEmail }}</p>
                  </td>
                  <td align="left">
                    {{ item.approverName }} <br />
                    <p class="text-primary">{{ item.approverEmail }}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <HistoryInfo :dataContract="dataContract"></HistoryInfo>
      </div>
    </div>
    <ModalEdiDevice
      @close="showModalEditDevice = false"
      :showModalEditDevice="showModalEditDevice"
      :dataContract="dataContract"
      :dataEdit="dataEditDevice"
      @closeSuccess="showModalEditDevice = false"
      @refeshData="getDetailContract()"
    />
    <addPDF
      :showModalAddBillImages="showModalAddPDF"
      :dataImagesContract="dataPDFContract"
      :dataContract="dataContract"
      :generalImages="generalImages"
      @successImg="successUploadImg"
      @errorImg="showFailMx"
      @submitAddBillImages="addPDFImages"
      @close="closeAddImages('pdf')"
    >
    </addPDF>

    <addBillImages
      :showModalAddBillImages="showModalAddBillImages"
      :dataImagesContract="dataBillImg"
      :dataContract="dataContract"
      :generalImages="generalImages"
      @successImg="successUploadImg"
      @errorImg="showFailMx"
      @submitAddBillImages="addBillImages"
      @close="closeAddImages('bill')"
    >
    </addBillImages>

    <addDKKDImages
      :showModalAddDKKDImages="showModalAddDKKDImages"
      :dataImagesContract="dataDKKDImg"
      :dataContract="dataContract"
      :generalImages="generalImages"
      @successImg="successUploadImg"
      @errorImg="showFailMx"
      @submitAddDKKDImages="addDKKDImages"
      @close="closeAddImages('dkkd')"
    >
    </addDKKDImages>

    <addStoreImages
      :showModalAddStoreImages="showModalAddStoreImages"
      :dataImagesContract="dataImgStores"
      :dataIdStores="dataIdStores"
      :dataContract="dataContract"
      @successImg="successUploadImg"
      @errorImg="showFailMx"
      @submitAddImagesStore="addStoreImages"
      @close="closeAddImages('store')"
    >
    </addStoreImages>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <SelectEmployee @selectSale="assignNewSale" />
    <PopupApproveContract
      :customer-type="customerInfo?.customerType"
      ref="popupApproveContractRef"
      @approveContract="getDetailContract"
    />

    <UploadContractModal
      ref="uploadModal"
      :visible="showUploadModal"
      :initialData="contractData"
      @update:visible="showUploadModal = $event"
      @load="getDetailContract"
      :contractId="dataContract?.id"
      :customerId="dataContract?.customerId"
      :type="isType"
      :reqSellCode="dataContract?.reqSellCode"
    />

    <UpdateStatusModal
      :visible="showUpdateStatusModal"
      :contractId="dataContract.id"
      :defaultStatus="dataContract.megabizStt"
      @update:visible="showUpdateStatusModal = $event"
      @success="handleUpdateSuccess"
      @error="handleUpdateError"
      @close="showUpdateStatusModal = false"
    />
    <ReserveContractModal
      :contract-id="dataContract.id"
      ref="reserveContractModal"
      @loading="showLoading = $event"
      @success="showSuccessMx"
      @error="showFailMx"
      @refresh="getDetailContract"
    />
  </div>
</template>

<script>
  import compact from 'lodash/compact'
  import { ContractService } from '@/services/contract.service'
  import Config from '../../thirdParty/config'
  import ModalEdiDevice from './modal-detail-contract-paper/edit-device-contract-paper.vue'
  import AddPDF from './modal-add-image/pdf-add-file.vue'
  import AddBillImages from './modal-add-image/bill-add-images'
  import AddDKKDImages from './modal-add-image/dkkd-add-images'
  import AddStoreImages from './modal-add-image/store-add-images'
  import HistoryInfo from './component/HistoryInfo.vue'
  import UploadContractModal from './component/UploadContractModal.vue'
  import UpdateStatusModal from './UpdateStatusModal.vue'
  import { mapGetters } from 'vuex'

  import mxActions from './/mxActions'
  export default {
    data() {
      return {
        Config,
        dataContract: {},
        showUpdateStatusModal: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataConfigMcc: [],
        showModalEditDevice: false,
        dataEditDevice: {},
        dataPDFContract: [],
        dataBillImg: [],
        dataDKKDImg: [],
        dataPassportImg: [],
        generalImages: [],
        showModalAddPDF: false,
        showModalAddBillImages: false,
        showModalAddDKKDImages: false,
        showModalAddStoreImages: false,
        dataImgStores: [],
        dataIdStores: '',
        showLoading: false,
        historyUpdate: [],
        historyAssignSale: [],
        showUploadModal: false,
        isType: '',
        contractData: {
          merchant: [],
          cccd: [],
          pdf: [],
          contract: [],
        },
        statusOptions: [],
      }
    },

    components: {
      addPDF: AddPDF,
      addBillImages: AddBillImages,
      addStoreImages: AddStoreImages,
      addDKKDImages: AddDKKDImages,
      ModalEdiDevice: ModalEdiDevice,
      HistoryInfo,
      UploadContractModal,
      UpdateStatusModal,
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    mixins: [mxActions],
    async created() {
      this.fetchDataMegabiz()
      await this.getDetailContract()
      this.configSystem()
      await this.getHistoryUpdate()
      this.historySaleAssigned()
    },
    methods: {
      compact,
      async fetchDataMegabiz() {
        try {
          this.loading = true
          const data = await ContractService.getListStatusMegabiz({})
          if (data.success) {
            const list = data.data.contractStt || []
            this.statusOptions = list.map(e => ({
              id: e.code,
              text: e.name,
              ...e,
            }))
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      openUpdateStatusModal() {
        this.showUpdateStatusModal = true
      },

      handleUpdateSuccess(data) {
        this.showSuccessMx(data.message)
        // Refresh data nếu cần
        this.getDetailContract()
      },

      handleUpdateError(error) {
        this.showFailMx(error.message)
      },
      // Mở modal
      openUploadModal() {
        this.showUploadModal = true
        // Hoặc dùng: this.$refs.uploadModal.show()
      },

      async getDetailContract() {
        try {
          this.showLoading = true
          const data = await ContractService.getDetailPaperContractById({
            contractId: this.$route.params.id,
          })
          if (data.data.id) {
            this.dataContract = data.data
            if (this.dataContract.generalImages) {
              const pdf = this.dataContract.generalImages.filter(item => item.dataType === 'PDF')
              this.dataPDFContract = pdf
              const bill = this.dataContract.generalImages.filter(item => item.dataType === 'BILL')
              this.dataBillImg = bill
              const mc = this.dataContract.generalImages.filter(
                item => item.dataType === 'BUSINESSREG'
              )

              this.dataDKKDImg = mc
              const cmnd = this.dataContract.generalImages.filter(item => item.dataType === 'CMND')
              this.dataPassportImg = cmnd

              this.contractData.cccd = cmnd
              this.contractData.merchant = data.data.typeCustomer !== 'INDIVIDUAL' ? mc : bill || []
              this.isType = data.data.typeCustomer !== 'INDIVIDUAL' ? 'BUSINESSREG' : 'BILL'
              this.contractData.pdf = pdf
              // this.contractData.contract = []

              this.generalImages = this.dataContract.generalImages
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      addPDFImages(data) {
        this.dataPDFContract = data.dataImages
        this.showModalAddPDF = false
      },
      addBillImages(data) {
        this.dataBillImg = data.dataImages
        this.showModalAddBillImages = false
      },
      addDKKDImages(data) {
        this.dataDKKDImg = data.dataImages
        this.showModalAddDKKDImages = false
      },
      addStoreImages(data) {
        this.dataContract.stores = data.dataImages
        this.showModalAddStoreImages = false
      },

      showAddImages(typeImage, data) {
        if (typeImage === 'pdf') this.showModalAddPDF = true
        if (typeImage === 'selfie') this.showModalAddBillImages = true
        if (typeImage === 'cuahang') {
          this.showModalAddStoreImages = true
          this.dataImgStores = this.dataContract.stores.filter(e => e.areaId === data)
          this.dataIdStores = data
        }
        if (typeImage === 'dkkd') this.showModalAddDKKDImages = true
      },

      async removeImg(index, key) {
        this.showmodalConfirmRemoveImage = true

        if (key === 'selfie') {
          this.typeImgAction = 'Ảnh hoá đơn/Ảnh selfie với cửa hàng/Ảnh sản phẩm...'
        }
        if (key === 'dkkd') {
          this.typeImgAction = 'Ảnh giấy phép KD/Ảnh selfie/Ảnh sản phẩm/Ảnh cửa hàng...'
        }
        if (key === 'cuahang') this.typeImgAction = 'ảnh cửa hàng'
        if (key === 'filePDF') this.typeImgAction = 'file PDF'
      },

      successUploadImg(key) {
        this.showLoading = false
        if (key === 0) {
          this.showSuccessMx('Thêm phụ lục thành công')
        }
        if (key === 1) {
          this.showSuccessMx('Cập nhật ảnh thành công')
        }
        if (key === 2) {
          this.showSuccessMx('Cập nhật file PDF thành công')
        }
      },

      closeAddImages(key) {
        if (key === 'pdf') this.showModalAddPDF = false
        if (key === 'bill') this.showModalAddBillImages = false
        if (key === 'store') this.showModalAddStoreImages = false
        if (key === 'dkkd') this.showModalAddDKKDImages = false
        setTimeout(() => {
          this.getDetailContract()
        }, 200)
      },
      async showEditDevice(data) {
        this.showModalEditDevice = true
        this.dataEditDevice = data
      },
    },
  }
</script>

<style scoped>
  .btn .bx {
    font-size: 18px;
  }

  .dropdown-item button {
    border: 1px;
  }
</style>
